import { reqGetMyPageInfo, reqGetUserInfo } from '../api';
import { policyHome } from '../api/api_home';
import Toast from 'vant/es/toast';
import { deepCopy } from '../utils';

/**
 * 获取用户信息
 * @param commit
 */
export const getUserInfo = ({commit}) => {
	let params = {
		token:  localStorage.getItem('token'),
		channel: 3
	}
	reqGetUserInfo(params).then((res)=>{
		if(res.ok) {
			let data = res.data
			// 存储在vuex
			commit('SET_LOGIN_INFO', data)
		}
	})
}

/**
 * 获取个人权益等信息
 * @param commit
 * @param data
 */
export const getMyPageInfo = ({commit}, data)=> {
	let params = {
		channel: 3,
		token: localStorage.getItem('token')
	}
	setTimeout(()=>{
		reqGetMyPageInfo(params).then(res=>{
			if(res.ok) {
				// 存储在vuex
				let resData = deepCopy(res.data)
				commit('SET_LOGIN_INFO', resData)
				sessionStorage.setItem('userInfo', JSON.stringify(resData));
			}else {
				// 处理各种code码错误情况和登录过期等问题
				if(res.code=== '000003' || res.code=== '000002') {
					// 不拦截海报页
					if(window.location.href.indexOf('/specialposter')> -1 || window.location.href.indexOf('/detail')> -1){
						return
					}
					if(data && data.router){
						let router = data.router
						if(localStorage.getItem('s') === 'BS') {
							router.push('/home')
						} else {
							router.push('/login')
						}
					}
				} else {
					Toast(res.msg)
				}
			}
		})
	})
}

/**
 * 消息列表改变
 * @param commit
 * @param data
 */
export const changeMsgList =  ({commit, state}, messageLogId)=>{
	let list = deepCopy(state.messageList)
	if(list.length){
		list.map((item)=>{
			if(item.messageLogId === messageLogId && !item.isRead){
				item.isRead = 1
			}
		})
		commit('SET_MESSAGELIST', list)
	}
}

export const changePolicyHome =  ({commit})=>{
	policyHome().then(res => {
		if(res.ok) {
			commit('SET_LEFTVISITTIMES', res.data.leftVisitTimes)
		}
	})
}
